import { useState } from "react";
import Header from "@/components/Header";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface ReportedName {
  id: string;
  name: string;
  reportCount: number;
  status: "pending" | "approved" | "rejected";
  reportedAt: string;
  reason: string;
}

const Moderation = () => {
  const { toast } = useToast();
  const [reportedNames, setReportedNames] = useState<ReportedName[]>([
    {
      id: "1",
      name: "ScamCoin",
      reportCount: 5,
      status: "pending",
      reportedAt: "2024-01-19T08:48:34Z",
      reason: "Potentially misleading name",
    },
    {
      id: "2",
      name: "SafeMoon2",
      reportCount: 3,
      status: "pending",
      reportedAt: "2024-01-19T07:30:00Z",
      reason: "Copycat of existing project",
    },
  ]);

  const handleApprove = (id: string) => {
    setReportedNames(names =>
      names.map(name =>
        name.id === id ? { ...name, status: "approved" } : name
      )
    );
    toast({
      title: "Name Approved",
      description: "The reported name has been approved.",
    });
  };

  const handleReject = (id: string) => {
    setReportedNames(names =>
      names.map(name =>
        name.id === id ? { ...name, status: "rejected" } : name
      )
    );
    toast({
      title: "Name Rejected",
      description: "The reported name has been rejected.",
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Name Moderation</h1>
          <Badge variant="outline">
            {reportedNames.filter(n => n.status === "pending").length} Pending
          </Badge>
        </div>

        <Card className="p-6">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Reports</TableHead>
                <TableHead>Reason</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Reported At</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {reportedNames.map(report => (
                <TableRow key={report.id}>
                  <TableCell className="font-medium">{report.name}</TableCell>
                  <TableCell>{report.reportCount}</TableCell>
                  <TableCell>{report.reason}</TableCell>
                  <TableCell>
                    <Badge
                      variant={
                        report.status === "approved"
                          ? "secondary"
                          : report.status === "rejected"
                          ? "destructive"
                          : "default"
                      }
                    >
                      {report.status}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    {new Date(report.reportedAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {report.status === "pending" && (
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleApprove(report.id)}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="destructive"
                          size="sm"
                          onClick={() => handleReject(report.id)}
                        >
                          Reject
                        </Button>
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </main>
    </div>
  );
};

export default Moderation;